module.exports = __webpack_public_path__ + "assets/img/2021-6-active.9a94a95d.png";